export const permissionsRolesReadonly = [
  "roles-full",
  "roles-readonly",
  "everything-full",
  "everything-readonly",
];
